<!-- 产品装小箱管理 -->
<template>
    <div class="container">
        <div class="header">
            <Input class="w300 mr-24 mb-24" type="text" v-model="storePrams.qrcode_number" placeholder="请输入或扫描产品溯源码编码查询外箱"></Input>
            <Input class="w200 mr-24 mb-24" type="text" v-model="storePrams.box_number" placeholder="请输入或扫描外箱码查询"></Input>
            <Select class="w200 mr-24 mb-24" v-model="storePrams.batch_id" clearable filterable placeholder="请选择关联批次">
                <Option v-for="item in batchList" :value="item.id" :key="item.id">{{ item.batch_name }}</Option>
            </Select>
            <Select class="w200 mr-24 mb-24" v-model="storePrams.product_id" clearable filterable placeholder="请选择关联产品">
                <Option v-for="item in productList" :value="item.id" :key="item.id">{{ item.product_name }}</Option>
            </Select>
            <Button class="theme-bg mb-24" icon="ios-search" type="warning" @click="goSearch">确定搜索</Button>
        </div>
        <div class="content">
            <div>
                <Button class="theme-bg mr-24 mb-24" type="warning" @click="goPacking">产品新装箱操作</Button>
                <Button class="mr-24 mb-24" type="warning" ghost @click="goRepair">补标入箱操作</Button>
                <Button class="mr-24 mb-24" type="warning" ghost @click="goUnpacking">拆标出箱(拆箱操作)</Button>
                <Table ref="selection" :columns="columnsTable" :data="dataTable" border @on-selection-change="changeSelection">
                    <template slot-scope="{ index }" slot="id">
                        <div>{{ index + 1 }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button type="success" ghost label="small" @click="goDetails(row)">详情</Button>
                            <Button type="error" ghost label="small" @click="goDel(1, row)">删除</Button>
                        </div>
                    </template>
                </Table>
            </div>
            <div class="page">
                <div>
                    <Checkbox class="checkbox-ml" v-model="del_value" @on-change="handleSelectAll">全选</Checkbox>
                    <span class="mr-24 ml-24">已经选择{{delData.length}}个</span>
                    <Button type="error" ghost label="large" @click="goDel(0)">删除</Button>
                </div>
                <Page :current="storePrams.page" :page-size="storePrams.limit" :total="total" show-elevator show-total @on-change="pageChange"/>
            </div>
        </div>
        <!-- Drawer -->
        <Drawer v-model="drawerModal" :title="drawerTitle" width="80">
            <Table v-if="drawerId == 1" :columns="columnsDrawer" :data="dataDrawer" border>
                <template slot-scope="{ index }" slot="id">
                    <div>{{ index + 1 }}</div>
                </template>
                <template slot-scope="{ row }" slot="product_imgs">
                    <div class="flex-c">
                        <img class="table_img" v-if="row.product_qrcode.product.product_imgs" src="../../assets/example1.png">
                        <img class="table_img" v-else src="../../assets/example1.png">
                    </div>
                </template>
                <template slot-scope="{ row }" slot="product_name">
                    <div>{{row.product_qrcode ? row.product_qrcode.product.product_name : ''}}</div>
                </template>
                <template slot-scope="{ row }" slot="specs">
                    <div>{{row.product_qrcode ? row.product_qrcode.product.specs : ''}}</div>
                </template>
                <template slot-scope="{ row }" slot="qrcode_number">
                    <div>{{row.product_qrcode ? row.product_qrcode.qrcode_number : ''}}</div>
                </template>
            </Table>
            <div v-if="drawerId == 1" class="page_drawer">
                <Page :current="pageDrawer.page" :page-size="pageDrawer.limit" :total="totalDrawer" show-elevator show-total @on-change="changeDrawer"/>
            </div>
            <div v-if="drawerId == 2">
                <Form :model="formData" label-position="right" :label-width="100">
                    <div class="form_header">
                        <img  class="width_height_24 mr-12" src="../../assets/information.png">
                        <div style="color: #FF761D;">为规范操作，如果需要装箱的产品之前装过箱，后台装箱需要将该产品拆箱后再装，否则会过滤该产品并提示已装过箱。 </div>
                    </div>
                    <FormItem label="外箱码：">
                        <div class="display_flex">
                            <Input class="width_30 mr-24" search v-model="formData.small_box_number" enter-button="随机生成" placeholder="录入已有外箱码或随机生成一个外箱码" @on-search="getPackingCountRound"/>
                            <Tooltip max-width="250" placement="right" theme="light">
                                <Icon class="ml-24 cursor-p" type="md-help-circle" size="20" color="#FF761D"/>
                                <div slot="content"><p>推荐提前印好箱码，然后扫码装箱关联。</p></div>
                            </Tooltip>
                        </div>
                    </FormItem>
                    <FormItem label="录入产品码：">
                        <Input class="width_30 mr-24" type="textarea" v-model="qrcode_number" :autosize="{minRows: 10}" placeholder="录入产品上的溯源码编码，一行一个，支持手工录入和扫码枪扫码录入"></Input>
                        <Tooltip max-width="250" placement="right" theme="light">
                            <Icon class="ml-24 cursor-p" type="md-help-circle" size="20" color="#FF761D"/>
                            <div slot="content"><p>支持手动和扫码枪扫码录入。</p></div>
                        </Tooltip>
                    </FormItem>
                    <div class="ta-r">
                        <Button class="mr-24" @click="cancelDrawer">取消</Button>
                        <Button class="theme-bg" type="warning" @click="submitDrawer">确定装箱</Button>
                    </div>
                </Form>
            </div>
            <div v-if="drawerId == 3">
                <Form :model="formData" label-position="right" :label-width="100">
                    <div class="form_header">
                        <img  class="width_height_24 mr-12" src="../../assets/information.png">
                        <div style="color: #FF761D;">为规范操作，如果需要装箱的产品之前装过箱，后台装箱需要将该产品拆箱后再装，否则会过滤该产品并提示已装过箱。 </div>
                    </div>
                    <FormItem label="外箱码：">
                        <div class="display_flex">
                            <Input class="width_30 mr-24" type="text" v-model="formData.small_box_number" placeholder="录入要补标的外箱码"/>
                            <Tooltip max-width="250" placement="right" theme="light">
                                <Icon class="ml-24 cursor-p" type="md-help-circle" size="20" color="#FF761D"/>
                                <div slot="content"><p>支持手工录入和扫码枪扫码录入</p></div>
                            </Tooltip>
                        </div>
                    </FormItem>
                    <FormItem label="溯源码数据：">
                        <Input class="width_30 mr-24" type="textarea" v-model="qrcode_number" :autosize="{minRows: 10}" placeholder="录入产品上的溯源码编码，一行一个，支持手工录入和扫码枪扫码录入"></Input>
                        <Tooltip max-width="250" placement="right" theme="light">
                            <Icon class="ml-24 cursor-p" type="md-help-circle" size="20" color="#FF761D"/>
                            <div slot="content"><p>录入要补箱的溯源码数据。</p></div>
                        </Tooltip>
                    </FormItem>
                    <div class="ta-r">
                        <Button class="mr-24" @click="cancelDrawer">取消</Button>
                        <Button class="theme-bg" type="warning" @click="submitDrawer">补标入箱</Button>
                    </div>
                </Form>
            </div>
            <div v-if="drawerId == 4">
                <Form :model="formData" label-position="right" :label-width="100">
                    <FormItem label="溯源码数据：">
                        <Input class="width_30 mr-24" type="textarea" v-model="qrcode_number" :autosize="{minRows: 10}" placeholder="一行一个，支持手工录入和扫码枪扫码录入"></Input>
                        <Tooltip max-width="250" placement="right" theme="light">
                            <Icon class="ml-24 cursor-p" type="md-help-circle" size="20" color="#FF761D"/>
                            <div slot="content"><p>录入要移出箱的溯源码数据。</p></div>
                        </Tooltip>
                    </FormItem>
                    <div class="ta-r">
                        <Button class="mr-24" @click="cancelDrawer">取消</Button>
                        <Button class="theme-bg" type="warning" @click="submitDrawer">确定</Button>
                    </div>
                </Form>
            </div>
        </Drawer>
    </div>
</template>

<script>
import { 
    packing_small_list, 
    packing_small_delete, 
    packing_small_tostart, 
    packing_small_product, 
    packing_count_round, 
    packing_unpack,
} from '@/api/index';
import { batch_select, product_select, } from '@/api/select';
export default {
    data() {
        return {
            qrcode_number: "",
            small_box_number: "",
            storePrams: {
                page: 1,
                limit: 10,
                qrcode_number: "",
                box_number: "",
                batch_id: "",
                product_id: "",
            },
            total: 0,
            batchList: [],
            productList: [],
            columnsTable: [
                { type: 'selection', width: 60, align: 'center' },
                { title: "#", slot: "id", align: "center", width: "60px" },
                { title: "小箱外箱码", key: "small_box_number", align: "center" },
                { title: "关联大箱码", key: "big_box_number", align: "center" },
                { title: "装箱数量", key: "count", align: "center" },
                { title: "操作", slot: "operate", align: "center", width: "200px" },
            ],
            dataTable: [],
            drawerModal: false,
            drawerTitle: "",
            drawerId: 0,
            columnsDrawer: [
                { title: "#", slot: "id", align: "center", width: "60px" },
                { title: "图片", slot: "product_imgs", align: "center" },
                { title: "产品名称", slot: "product_name", align: "center" },
                { title: "规格", slot: "specs", align: "center" },
                { title: "产品编码", slot: "qrcode_number", align: "center" },
            ],
            dataDrawer: [],
            // selection
            del_id: "",
            delData: [],
            del_value: false,
            pageDrawer: {
                page: 1,
                limit: 10,
            },
            totalDrawer: 0,
            formData: {
                qrcode_number: [],
                small_box_number: "",
                is_round: 0,
                is_exist: 0,
            },
        };
    },
    mounted() {
        this.getList();
        this.getBatchSelect();
        this.getProductSelect();
    },
    methods: {
        // 产品装小箱列表
        getList() {
            packing_small_list(this.storePrams).then((res) => {
                this.dataTable = res.data.data;
                this.total = res.data.total;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        // 小箱中产品列表
        getPackingSmallProduct(){
            packing_small_product({small_box_number: this.small_box_number}).then((res) => {
                this.dataDrawer = res.data.data;
                this.totalDrawer = res.data.total;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        // 批次下拉
        getBatchSelect(){
            batch_select().then((res) => {
                this.batchList = res.data;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        // 产品下拉
        getProductSelect(){
            product_select().then((res) => {
                this.productList = res.data;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        changeDrawer(index){
            this.pageDrawer.page = index;
            this.getList();
        },
        goSearch() {
            this.getList();
        },
        goDetails(row){
            this.small_box_number = row.small_box_number;
            this.getPackingSmallProduct();
            this.drawerTitle = row.small_box_number + "小箱详情";
            this.drawerId = 1;
            setTimeout(() => {
                this.drawerModal = true;
            }, 300);
        },
        goPacking(){
            this.formData.is_exist = 0;
            this.formData.qrcode_number = [];
            this.formData.small_box_number = "";
            this.formData.is_round = 0;
            this.qrcode_number = "";
            this.drawerTitle = "产品新装箱操作";
            this.drawerId = 2;
            this.drawerModal = true;
        },
        goRepair(){
            this.formData.is_exist = 1;
            this.formData.qrcode_number = [];
            this.formData.small_box_number = "";
            this.formData.is_round = 0;
            this.qrcode_number = "";
            this.drawerTitle = "补标入箱操作";
            this.drawerId = 3;
            this.drawerModal = true;
        },
        goUnpacking(){
            this.formData.qrcode_number = [];
            this.qrcode_number = "";
            this.drawerTitle = "拆标出箱(拆箱操作)";
            this.drawerId = 4;
            this.drawerModal = true;
        },
        goDel(index, row){
            if(index == 0 && this.delData.length == 0){
                this.$Message.error('请选择');
                return
            }
            let that = this;
            this.$Modal.confirm({
                title: '是否确定取消该小箱？',
                content: '取消该小箱操作将使箱内产品移出，处于未装箱状态',
                onOk: () => {
                    if(index == 0){
                        var del_id = [];
                        this.delData.forEach(item => {
                            del_id.push(item.small_box_number)
                        });
                        this.del_id = del_id.join(',');
                        packing_small_delete({ small_box_number: this.del_id }).then(res=>{
                            that.getList();
                            this.$Message.success(res.msg);
                        }).catch(res=>{
                            this.$Message.error(res.msg);
                        })
                    }else if(index == 1){
                        packing_small_delete({ small_box_number:row.small_box_number }).then(res=>{
                            that.getList();
                            this.$Message.success(res.msg);
                        }).catch(res=>{
                            this.$Message.error(res.msg);
                        })
                    }
                },
                onCancel: () => {
                }
            }); 
        },
        // selection
        changeSelection(e){
            this.delData = e;
            if(this.dataTable.length === e.length){
                this.del_value = true;
            }else{
                this.del_value = false;
            }
        },
        handleSelectAll(e){
            if(e == true){
                this.delData = this.dataTable;
                this.$refs.selection.selectAll(true);
            }else{
                this.$refs.selection.selectAll(false);
            }
        },
        getPackingCountRound(){
            this.formData.is_round = 1;
            packing_count_round().then( res => {
                this.formData.small_box_number = res.data;
            }).catch(res=>{
                this.$Message.error(res.msg);
            })
        },
        // 确定
        submitDrawer(){
            if(this.qrcode_number){
                this.formData.qrcode_number = this.qrcode_number.split('\n').map((item, index) => {
                    if (item === '') {
                        // 如果是空字符串，表示这里有一个换行
                        return null;
                    }
                    return item;
                });
            }
            if(this.drawerId == 4){
                packing_unpack({qrcode_number: this.formData.qrcode_number}).then( res => {
                    this.getList();
                    this.drawerModal = false;
                    this.$Message.success(res.msg);
                }).catch(res=>{
                    this.$Message.error(res.msg);
                }) 
                return
            }
            this.formData.qrcode_number = this.formData.qrcode_number.filter(item => item != null);
            packing_small_tostart(this.formData).then( res => {
                this.getList();
                this.drawerModal = false;
                this.$Message.success(res.msg);
            }).catch(res=>{
                this.$Message.error(res.msg);
            }) 
        },
        cancelDrawer(){
            this.drawerModal = false;
        }
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.header {
    padding: 24px 24px 0 24px;
    margin-bottom: 24px;
    background-color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.form_header {
    margin-bottom: 24px;
    padding: 24px;
    display: flex;
    align-items: center;
}
.width_height_24 {
    width: 24px;
    height: 24px;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.page {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
}
.page_drawer {
    margin-top: 24px;
    text-align: right;
    white-space: nowrap;
}
.table_img {
    margin: 12px 0;
    width: 60px;
    height: 60px;
}
::v-deep .ivu-input-search {
    background: #53C41A !important;
    border-color: #53C41A !important;
}
::v-deep .ivu-checkbox{
    margin-right: 24px;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #ff761d;
    background-color: #ff761d;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
.display_flex {
    display: flex;
}
.width_30 {
    width: 30vw;
}
</style>